
import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const SwedishInfoPage = () => {
  return (
    <div className="container mx-auto px-4 py-12 max-w-5xl">
      <Helmet>
        <title>Information | Lainasampo</title>
        <meta name="description" content="Viktig information om våra lånetjänster och juridiska villkor på svenska." />
      </Helmet>

      <div className="mb-8">
        <h1 className="text-4xl font-bold text-primary mb-4">Viktig Information</h1>
        <p className="text-lg text-gray-600">
          Denna sida innehåller viktig information om våra tjänster och juridiska dokument på svenska.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-12">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Användarvillkor</h2>
          <p className="mb-6">
            Våra användarvillkor förklarar förutsättningarna för att använda våra lånejämförelsetjänster,
            inklusive dina rättigheter och skyldigheter.
          </p>
          <Link to="/sv/terms">
            <Button variant="outline" className="w-full">Visa Användarvillkor</Button>
          </Link>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <h2 className="text-2xl font-bold mb-4">Integritetspolicy</h2>
          <p className="mb-6">
            Vår integritetspolicy beskriver hur vi hanterar dina personuppgifter,
            inklusive vad vi samlar in och hur vi använder dem.
          </p>
          <Link to="/sv/privacy">
            <Button variant="outline" className="w-full">Visa Integritetspolicy</Button>
          </Link>
        </div>
      </div>

      <div className="bg-blue-50 p-6 rounded-lg mb-12">
        <h2 className="text-2xl font-bold mb-4">Kundtjänst</h2>
        <p className="mb-4">
          Om du har frågor om våra tjänster eller behöver hjälp,
          finns vårt kundtjänstteam tillgängligt för att hjälpa dig.
        </p>
        <p className="mb-4">
          E-post: <a href="mailto:info@lainasampo.fi" className="text-primary hover:underline">info@lainasampo.fi</a>
        </p>
        <div className="flex flex-wrap gap-4 mt-6">
          <Link to="/swedish">
            <Button variant="secondary">Tillbaka till Svenska Startsidan</Button>
          </Link>
          <Link to="/swedish/apply">
            <Button>Ansök om Lån</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SwedishInfoPage;
